import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { CircularProgress, IconButton } from '@mui/material';
import PropTypes from 'prop-types';

import styles from '../styles.module.css';

function AgreementSignButton({
    link,
    linkText,
    isExternalLink,
    onDocumentSign,
    disabled,
    isSigning,
}) {
    const history = useHistory();

    const handleLink = useCallback(
        (event) => {
            event.stopPropagation();
            if (isExternalLink) {
                onDocumentSign();
                window.open(link, '_blank');
            } else {
                history.push(link);
            }
        },
        [isExternalLink, onDocumentSign, link, history]
    );

    return (
        <>
            {link && (
                <IconButton
                    onClick={handleLink}
                    disabled={disabled || isSigning}
                    className={styles.sign_button}
                >
                    <span className={styles.sign_button_text}>{linkText}</span>
                    {isSigning && <CircularProgress size={13} color="inherit" />}
                </IconButton>
            )}
        </>
    );
}

AgreementSignButton.propTypes = {
    link: PropTypes.string,
    linkText: PropTypes.string,
    isExternalLink: PropTypes.bool,
    onDocumentSign: PropTypes.func,
    disabled: PropTypes.bool,
    isSigning: PropTypes.bool,
};

export default AgreementSignButton;
